import lang from './lang'
const nn = (t,l) =>{
  if(!lang[l]) return t
  return (lang[l][t]) ? lang[l][t]:t
}
export default {
  nn,
}